import { SidebarIcon } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Separator } from "@/components/ui/separator"
import { useSidebar } from "@/components/ui/sidebar"
import { Logo } from "./ui/logo"
import { HeaderClockDialog } from "./header-clock-dialog"
import { LocationDialog } from "./location-dialog"
import { OfflineStaleBadge } from "./offline-stale-badge"
import { useCacheStatus } from "@/contexts/cache-status-context"

export function SiteHeader() {
  const { toggleSidebar } = useSidebar()
  const { fromCache, isOffline } = useCacheStatus()

  return (
    <header className="glass-header fixed top-0 z-50 flex w-full items-center">
      <div className="flex h-(--header-height) w-full items-center gap-2 px-4">
        <Button
          className="size-8"
          variant="ghost"
          size="icon"
          onClick={toggleSidebar}
          aria-label="Toggle Sidebar Menu"
        >
          <SidebarIcon />
        </Button>
        <Separator orientation="vertical" className="mr-2 h-4" />
        <Logo size="large" className="hidden md:block" />
        <Logo size="small" className="block md:hidden" />
        <div className="ml-auto flex items-center gap-2">
          <OfflineStaleBadge fromCache={fromCache} isOffline={isOffline} />
          <LocationDialog />
          <HeaderClockDialog />
        </div>
      </div>
    </header>
  )
}
